<template>
  <div
    :id="this.id"
    :data-hide-desktop="!this.internal_config.showDesktop"
    :data-hide-mobile="!this.internal_config.showMobile"
    :config-properties="JSON.stringify(internal_config)"
    class="sitebuilder-element-container card big-is-receiver"
    :class="{'place-menu-collapse-show-on-hover': internal_config.typeOpenContainer === 'by-hover' && preview}"
    :style="style()"
    element="PlaceMenuComponent"
    :key="componentKey"
    @contextmenu.prevent="handler($event)"
    @click="focusElement($event)">

    <options-element-bar ref="optionsBar" :elem="this" name="ct-component-PlaceMenuComponent">
      <div
        v-tooltip="{content:$t('ct-option-prev-order'), class: 'tooltip-custom'}" class="mdi mdi-arrow-left-circle change-place-item-blue change-place-item-blue-prev"
        style="font-size: 20px;cursor: pointer"
        @click="callReorder(-1)"/>

      <div
        v-tooltip="{content:$t('ct-option-next-order'), class: 'tooltip-custom'}" class="mdi mdi-arrow-right-circle change-place-item-blue change-place-item-blue-next"
        style="font-size: 20px;cursor: pointer"
        @click="callReorder(1)"/>
    </options-element-bar>
    <div
      :id="'heading'+id" :style="{
        background: background,
        borderRadius: radius,
        height : height,
        border: '0 !important'
      }" class="card-header"
      @mouseover="handleMouseover($event)"
      @mouseleave="handleMouseleave($event)"
      @click="collapseThis($event)">
      <h5 class="mb-0 clean-text-css h-100">
        <button
          :style="textStyle()"
          :class="{'text-nowrap': !internal_config.enableLineBreak}"
          class="btn btn-link w-100 h-100 icon-place desktop-element big-menu-text"
        >{{ internal_config.text }}</button>
        <button
          :style="textStyleMobile()"
          :class="{'text-nowrap': !internal_config.enableLineBreak}"
          class="btn btn-link w-100 h-100 icon-place  mobile-element big-menu-text"
        >{{ internal_config.text }}</button>
      </h5>
    </div>

    <div
      :id="'place-menu-'+id"
      :style="getStyle()"
      class="place-menu-collapse card-body big-menu-place-childs"
    >
      <div
        :class="{'container': internal_config.positionContainer === 'width-full'}"
        class="sitebuilder-element-receiver real-place big-is-receiver">
        <component
          v-for="(element,index) in elements" :is="element.name" :config="element.config"
          :key="index"
          :id="element.id" :height_start="index" :preview="preview"
          :childs="element.childs"
          @setCallbackChangeDevice="setCallbackChangeDevice"/>
      </div>
    </div>
    <resources ref="resourcesData"/>
  </div>
</template>

<script>

import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from "../../OptionsElementBar";

export default {
  name: 'PlaceMenuComponent',
  components: {
    OptionsElementBar,
    Resources
  },
  props: ['config', 'childs', 'height_start', 'device', 'id', 'preview'],
  data() {
    return Data.data();
  },
  computed: {
    height() {
      return this.internal_config.height;
    },
    bottomMargin() {
      return typeof this.internal_config.bottomMargin !== 'undefined' ? this.internal_config.bottomMargin : 0;
    },
    border() {
      return this.internal_config.border;
    },
    radius() {
      return this.internal_config.borderRadius;
    },
    background() {
      return this.internal_config.backgroundColor;
    },
    topContainer() {
      return `${parseInt(this.height) + parseInt(this.bottomMargin)}px`;
    },
    heightContainer() {
      return this.internal_config.heightContainer;
    },
    leftMarginContainer() {
      return `-${this.internal_config.leftMargin}px`;
    },
    leftContainer() {
      if (this.internal_config.positionContainer === 'width-full') {

        let rect = document.getElementById(this.id).getBoundingClientRect();
        let docEl = document.documentElement;

        return (rect.left + (window.pageXOffset || docEl.scrollLeft || 0)) * -1 + 'px';
      } else if (this.internal_config.positionContainer === 'start-menu-item') {
        return '0px';
      }

      return this.internal_config.leftContainer;
    },
    widthContainer() {
      if (this.internal_config.positionContainer === 'width-full')
        return document.getElementById('editor-content').getBoundingClientRect().width + 'px';

      const widthContainer = parseInt(this.internal_config.widthContainer) + parseInt(this.internal_config.leftMargin);
      return `${widthContainer}px`;
    },
    borderContainer() {
      return this.internal_config.borderContainer;
    },
    radiusContainer() {
      return this.internal_config.borderRadiusContainer;
    },
    backgroundContainer() {
      return this.internal_config.backgroundColorContainer;
    },
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
        this.$eventPointer.log(this.id, value);

        if (this.internal_config.enableOnlyLink) {
          $('.place-menu-collapse:not(#place-menu-' + this.id)
            .hide();

          $('.big-menu-text').removeClass('selected');

          let elem = $('#place-menu-' + this.id);
          if (elem.is(":visible")) {
            elem.hide();
            document.getElementById('page-mask').hidden = true;
          }
        }
      }
    },
  },
  created() {
    this.componentKey = '1';
  },
  mounted() {

    let device, childs, id, config;
    ({device, childs, id, config} = this.$props);

    if (typeof config.backgroundColor === 'undefined')
      config.backgroundColor = '#FFFFFF';

    this.internal_config = config;
    this.device = device;

    if (typeof childs === 'undefined') {
      childs = [];
      this.internal_config.childs = [];
    }

    if (typeof id !== 'undefined')
      this.id = id;


    if (this.internal_config.animation)
      delete this.internal_config.animation;


    this.internal_config.name = 'big-menu-place';

    this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

    let internal_config = window.mergeRecursive(this.props, this.$props.config);
    this.internal_config = {...internal_config, ...this.internal_config};

    this.$root.$on('setConfigElement', (id, obj) => {
      id = id.replace('place-menu-', '');
      if (this.id == id) {
        this.config = obj;
        this.internal_config = obj;
      }
    });

    this.$root.$on('setChildsObj', (id) => {
      id = id.replace('place-menu-', '');
      if (this.id == id) {

        this.$eventPointer.logChilds(this.id, this.elements);

        let childsHub = this.$eventHub.getChilds(this.id);

        this.config.childs = childsHub;
        this.internal_config.childs = childsHub;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;

          this.$nextTick(() => {
            this.sendNewChilds();
            this.$root.$emit('activeSort');
            
            if(this.$refs.resourcesData)
              this.$refs.resourcesData.setValuesData(this);
          });
        });
      }
    });

    this.$root.$on('setChildsUndoRedo', (id, childs) => {
      if (this.id == id) {
        this.$eventHub.setChilds(this.id, childs);

        this.config.childs = childs;
        this.internal_config.childs = childs;

        this.elements = {};
        this.$nextTick(() => {
          this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
          this.componentKey += 1;
        });
      }
    });

    this.build();

    if(this.internal_config.widthContainerFull){
      this.internal_config.positionContainer = 'width-full';
    }

    this.$refs.resourcesData.setValuesData(this);
  },
  methods: {
    callReorder(idx) {
      if (typeof this.$parent.changeOrderPanel !== 'undefined')
        this.$parent.changeOrderPanel(this, idx);
       else
        this.$parent.$parent.changeOrderPanel(this, idx);

    },

    getStyle() {
      return {
        borderRadius: this.radiusContainer,
        background: this.backgroundContainer,
        marginLeft: this.leftMarginContainer,
        left: this.leftContainer,
        top: this.topContainer,
        height : this.heightContainer,
        width : this.widthContainer,
        border : this.borderContainer
      };
    },

    animation() {
      return false;
    },
    changeOrderPanel(elem, idx) {

      let id = elem.$el.id,
        sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

      if (sibling === null)
        return true;


      this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);

    },
    handleMouseover() {
      if (this.internal_config.typeOpenContainer === 'by-hover' && this.preview) {
        $('.place-menu-collapse:not(#place-menu-' + this.id)
          .hide();

        $('.big-menu-text').removeClass('selected');
        $('.zindexBig').removeClass('zindexBig');
      }
    },
    handleMouseleave() {
    },
    collapseThis(e) {

      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();

      $('.place-menu-collapse:not(#place-menu-' + this.id)
        .hide();

      $('.big-menu-text').removeClass('selected');

      if (this.internal_config.enableOnlyLink) {
        if (this.preview)
          this.$root.$emit('linkAction', this.internal_config.link);

        return;
      }

      let elem = $('#place-menu-' + this.id);
      if (elem.is(":visible")) {
        elem.hide();
        document.getElementById('page-mask').hidden = true;
      } else {
        document.getElementById('page-mask').hidden = false;
        elem.show().parents('.big-is-receiver.card').find('.big-menu-text').addClass('selected');
        document.body.style.setProperty('--big-menu-item-background--selected', this.internal_config.backgroundColorSelected);
        document.body.style.setProperty('--big-menu-item-color--selected', this.internal_config.textColorSelected);
      }

    },

    focusElement(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this);

      e.stopPropagation();
      e.preventDefault();
    },
    handler: function(e) {
      this.$root.$emit('focusElement', this);
      this.$root.$emit('handlerElement', this, true);

      e.stopPropagation();
      e.preventDefault();

    },
    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },
    style() {
      return `left:  ${this.internal_config.left};
                top: ${this.internal_config.top};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                z-index: ${this.internal_config.zIndex};
                width: ${this.internal_config.width};
                max-width: ${this.internal_config.maxWidth} !important;
                border: 0 !important;
                margin: 0 auto;`;
    },
    setCallbackChangeDevice(values) {
      this.$emit('setCallbackChangeDevice', values);
    },
    build() {

      this.buildIcon();
      $('.place-menu-collapse').hide();

      this.internal_config.leftContainer = (document.getElementById(this.id).offsetLeft * -1) + 'px';

      let vm = this;
      this.$el.addEventListener('mouseover', function() {
        document.body.style.setProperty('--big-menu-item-background--hover', vm.internal_config.backgroundColorHover);
        document.body.style.setProperty('--big-menu-item-color--hover', vm.internal_config.textColorHover);
      });
    },

    textStyle() {

      if (typeof this.internal_config.textStyle == 'undefined') {
        this.internal_config.textStyle = {
          'family': 'arial, helvetica, sans-serif',
          'size': '15px',
          'sizeMobile': '15px',
          'color': 'White',
          'align': 'center',
          'weight': '700',
          'style': 'initial',
          'stroke': 'none'
        };
      }
      return {
        fontFamily: this.internal_config.textStyle.family,
        fontSize: this.internal_config.textStyle.size + ' !important',
        textAlign: this.internal_config.textStyle.align,
        fontWeight: this.internal_config.textStyle.weight,
        fontStyle: this.internal_config.textStyle.style,
        textDecoration: this.internal_config.textStyle.stroke,
        color: this.internal_config.textStyle.color,
        border: this.internal_config.border + ' !important',
        borderRadius: this.internal_config.borderRadius,
      };
    },
    textStyleMobile() {

      if (typeof this.internal_config.textStyle == 'undefined') {
        this.internal_config.textStyle = {
          'family': 'arial, helvetica, sans-serif',
          'size': '15px',
          'sizeMobile': '15px',
          'color': 'White',
          'align': 'center',
          'weight': '700',
          'style': 'initial',
          'stroke': 'none'
        };
      }

      return {
        fontFamily: this.internal_config.textStyle.family,
        fontSize: this.internal_config.textStyle.sizeMobile + ' !important',
        textAlign: this.internal_config.textStyle.align,
        fontWeight: this.internal_config.textStyle.weight,
        fontStyle: this.internal_config.textStyle.style,
        textDecoration: this.internal_config.textStyle.stroke,
        color: this.internal_config.textStyle.color,
        border: this.internal_config.border + ' !important',
        borderRadius: this.internal_config.borderRadius,
      };
    },
    buildIcon: function() {
      $(this.$el).find('i').detach();

      if (this.internal_config.icon !== '') {
        if (this.internal_config.iconPosition === 'left') {
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).prependTo($(this.$el).find('.icon-place').get(0));
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).prependTo($(this.$el).find('.icon-place').get(1));
        }
        if (this.internal_config.iconPosition === 'right') {
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).appendTo($(this.$el).find('.icon-place').get(0));
          $('<i>').addClass(this.$addIconPrefix(this.internal_config.icon)).appendTo($(this.$el).find('.icon-place').get(1));
        }
      }
    },
    sendNewChilds() {

      let vm = this;

      setTimeout(() => {
        vm.$eventPointer.changePointerState(true);
        vm.$eventPointer.logChilds(vm.id, vm.elements);
        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
        }, 500);
      }, 1000);
    },
  },
};

</script>
<style lang="scss">
[element="PlaceMenuComponent"] {
  &.sitebuilder-element-container.card {
    height: auto !important;
    width: 100% !important;
    top: 0 !important;
    left: 0 !important;
    position: relative;
    background-color: transparent !important;

    .real-place {
      height: 100%;
    }
  }

  .card-header {
    padding: 0 !important;
  }

  .place-menu-collapse {
    position: relative;
  }

  .big-menu-text {
    &:hover {
      background: var(--big-menu-item-background--hover);
      color: var(--big-menu-item-color--hover) !important;
    }

    &.selected {
      background: var(--big-menu-item-background--selected);
      color: var(--big-menu-item-color--selected) !important;
    }
  }

  .change-place-item-blue {
    display: none;
  }

  .card-body {
    position: relative;
  }
}
</style>

<style lang="scss" scoped>
.btn-link {
  padding: 0 4px !important;
}

.place-menu-collapse-show-on-hover {
  &:hover {
    .place-menu-collapse {
      display: block !important;
    }
  }
}

[data-device="tablet"],
[data-device="mobile"] {

  .big-menu-place-childs,
  .real-place {
    height: auto !important;
    width: 100% !important;
    top: 0 !important;
    left: 0 !important;
  }

  .card-header {
    height: auto !important;
  }

  .mobile-element.big-menu-text {
    display: block !important;
  }
}

[data-device="desktop"] {
  .big-menu-place-childs {
    position: absolute;
    z-index: 99;

    .real-place {
      position: relative;
    }
  }
}

[data-device="desktop"] {

  .desktop-element.big-menu-text {
    display: block !important;
  }

  [element="GroupMenuComponent"] {
    .change-place-item-blue {
      display: block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/BigMenu/PlaceMenu/PlaceMenu.vue